var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "novedades_main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_206",
    "data-name": "Rect\\xE1ngulo 206",
    width: 15,
    height: 15,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_28",
    "data-name": "Rect\\xE1ngulo 28",
    width: 10.434,
    height: 9.702,
    fill: "#b1cb79"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_20",
    "data-name": "Enmascarar grupo 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(2.5 2.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M0,6.274A2.045,2.045,0,0,1,.211,6Q1.766,4.568,3.327,3.139a.586.586,0,0,1,1.013.45c0,.31,0,.621,0,.945H6.347c.265,0,.379.115.38.379,0,.371,0,.742,0,1.148L9.66,3.37,6.727.678V.832c0,.342,0,.684,0,1.026a.309.309,0,0,1-.334.344q-2.3,0-4.6,0a.308.308,0,0,1-.33-.3.316.316,0,0,1,.317-.325c.043,0,.087,0,.13,0H6.1c0-.342,0-.669,0-1A.573.573,0,0,1,6.638,0a.633.633,0,0,1,.5.2q.8.74,1.606,1.476l1.521,1.4c.223.2.226.375.006.577L7.1,6.562a.584.584,0,0,1-1-.435c0-.316,0-.632,0-.969H4.093c-.262,0-.377-.117-.378-.382,0-.37,0-.741,0-1.146L.783,6.321,3.706,9c0-.054.009-.089.009-.123,0-.342,0-.684,0-1.026,0-.25.115-.366.364-.366H8.054c.232,0,.368.114.369.306s-.139.316-.377.316H4.339v.313c0,.212,0,.424,0,.636a.576.576,0,0,1-.486.624.164.164,0,0,0-.034.018h-.13a2.115,2.115,0,0,1-.383-.225Q1.746,8.061.2,6.63A1.691,1.691,0,0,1,0,6.352V6.274",
    transform: "translate(0 0)",
    fill: "#b1cb79"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/icon_transfer.694e3ce44c5cc7a0127f5df2e71de4da.svg";
export { ForwardRef as ReactComponent };